export function PageHeader({
  eyebrow,
  title,
  actions,
}: {
  eyebrow: string;
  title: string;
  actions?: React.ReactNode;
}) {
  return (
    <header
      className="flex h-16 shrink-0 items-center justify-between px-6 gap-4"
      style={{
        background: 'var(--glass-bg)',
        backdropFilter: 'blur(var(--glass-blur))',
        WebkitBackdropFilter: 'blur(var(--glass-blur))',
        borderBottom: '1px solid var(--glass-border)',
      }}
    >
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-widest text-text-secondary">{eyebrow}</div>
        <div className="text-xl font-bold text-text-primary leading-tight mt-0.5">{title}</div>
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
